import {
  AppBar,
  Button,
  ButtonGroup,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Tooltip,
  Typography
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';

import { fetchHtmlJsonApi } from "../../../../api's/DataProcessorApi";
import { AWS_CONFIG_TYPE, AZURE_BLOB_STORAGE } from '../../../../BaseUrl';
import { BUCKET_NAME } from '../../../../constants/Constant';
import { WorkflowContext } from '../../../../contexts/WorkflowProvider';
import RulesSelectorPage2 from '../../../../pages/RulesSelectorPage2';
import generateAlias from '../../../../utils/generateAlias';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const styleLoading = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
};

function NodeModalRulesSelector({ open, handleClose, changeNodeName, nodeName, nodeId, nodes, edges, setNodes }) {
  const { workflow } = useContext(WorkflowContext);

  const domain_name = workflow.engagement.client.depDomainEntity.domain_name;
  const client_name = workflow.engagement.client.client_name;
  const engagement_name = workflow.engagement.engagement_name;
  const workflow_name = workflow.workflow_name;
  const output_path = `${
    AWS_CONFIG_TYPE ? 'dep-qa' : 'dep-develop'
  }/${domain_name}/${client_name}/${engagement_name}/${workflow_name}/Output/${generateAlias(nodeName, nodeId)}`;
  const INITIALSTATE = {
    innerPath: '',
    format: '',
    persist: false,
    alias: generateAlias(nodeName, nodeId),
    snowflake_mode: '',
    snowflake_db_table: '',
    persist_type: '',
    partition: false,
    overwrite: false,
    df: '',
    p_key: '',
    index: '',
    database: '',
    tablename: '',
    db_type: '',
    mode: '',
    schema: '',
    col_list: [],
    distinct_rows: false,
    stream_interval: '',
    sample_view: true,
    path: `${!AWS_CONFIG_TYPE ? 'dep-develop' : 'dep-qa'}/${workflow.engagement.client.client_name}/${
      workflow.engagement.engagement_name
    }/${workflow.workflow_name}/Output/Data_Profiling/validation`,
    profilingPath: `${!AWS_CONFIG_TYPE ? 'dep-develop' : 'dep-qa'}/${workflow.engagement.client.client_name}/${
      workflow.engagement.engagement_name
    }/${workflow.workflow_name}/Output/Data_Profiling/profiling`,

    configData: [],
    configDataNew: [],
    rule_list: [],
  };

  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRules, setSelectedRules] = useState([]);
  // const [configData, setConfigData] = useState([]);
  const [headerName, setHeaderName] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [prevNodeName, setPrevNodeName] = useState('');
  const [tempHeader, setTempHeader] = useState([]);
  const [tableName, setTableName] = useState([]);
  const [toggleType, setToggleType] = useState('S3');

  const [uniqueId, setUniqueId] = useState('');
  const [columnName, setColumnName] = useState([]);
  const [selectedColumnName, setSelectedColumnName] = useState([]);
  const [configData, setConfigData] = useState([
    {
      id: 1,
      column: '',
      matchingCriteria: '',
    },
  ]);
  const { enqueueSnackbar } = useSnackbar();

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    // Check rule_list
    const hasErrorsInRuleList = formField.rule_list.some((el) => {
      if (el.checked) {
        if (!el.metric || !el.format || !el.field_name || !el.unit) {
          enqueueSnackbar('Please select Metric !!!', {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
          return true;
        }
        return false;
      }
    });

    if (hasErrorsInRuleList) return;

    // Check configDataNew
    const hasErrorsInConfigDataNew = formField.configDataNew.some((el) => {
      if (!el.statement || !el.field_name || !el.dataType || !el.metric) {
        enqueueSnackbar('All fields must be filled in Predefined Rules !!!', {
          variant: 'error',
          autoHideDuration: 3500,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        return true;
      }
      return false;
    });

    if (hasErrorsInConfigDataNew) return;

    // Check configData
    const hasErrorsInConfigData = formField.configData.some((el) => {
      if (!el.statement || !el.field_name || !el.metric) {
        enqueueSnackbar('All fields must be filled in Custom Rules !!!', {
          variant: 'error',
          autoHideDuration: 3500,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        return true;
      }
      return false;
    });

    if (hasErrorsInConfigData) return;

    const newHeaderName = [];

    headerName.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const sendFormData = {
      y_axis,
      nodeId,
      nodeName,
      formField,
      disabled: true,
      step_name: nodeName,
      headerName: newHeaderName,
      fetchedHeader,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const refreshAllState = () => {
    let updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem('updatedNodes', JSON.stringify(updateNodes));

    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);

      enqueueSnackbar('No source node is connected !!!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      return;
    }

    let nodesExist = false;

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            setPrevNodeName(node.step_name);
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });
      const isHeader = header.some((item) => item.header);

      if (isHeader) {
        const newArr = [];

        if (prevNodeName === 'Join') {
          header.forEach((el) => {
            const exist = el.header.split('.').length;

            if (exist === 2) {
              const head = el.header.split('.')[1];
              newArr.push({ ...el, header: el.alias ? el.alias : head });
            }
          });
        }
        if (newArr.length > 0) {
          header = newArr;
        }

        const uniqueHeader = [];

        const uniqueArray = header.filter((element) => {
          const isDuplicate = uniqueHeader.includes(element.header);

          if (!isDuplicate) {
            uniqueHeader.push(element.header);
            return true;
          }

          return false;
        });

        const head = [];

        const newHeader = uniqueArray.map((el) => {
          return { ...el, header: el.alias ? el.alias : el.header, alias: el.alias ? '' : el.alias };
        });

        newHeader.forEach((el) => {
          head.push({ label: el.header });
        });

        setHeaders(head);

        if (nodesExist) {
          store.forEach((node) => {
            if (node.nodeId === nodeId) {
              setFormField(node.formField);
              setHeaderName(node.headerName);
              setToggleType(node.toggleType);

              const nonExistingHeader = [];
              node.fetchedHeader.forEach((item) => {
                const index = newHeader.findIndex((x) => x.header === item.header);

                if (index !== -1) {
                  nonExistingHeader.push(item);
                }
              });

              newHeader.forEach((el) => {
                const index = nonExistingHeader.findIndex((x) => x.header === el.header);

                if (index === -1) {
                  nonExistingHeader.push({
                    ...el,
                    header: el.alias ? el.alias : el.header,
                    alias: el.alias ? '' : el.alias,
                  });
                }
              });

              setFetchedHeader(nonExistingHeader);
            }
          });
        } else {
          setFetchedHeader(newHeader);
        }
      } else {
        setFetchedHeader([]);
      }
    }

    enqueueSnackbar('Data Refreshed!!!', {
      variant: 'Success',
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
  };

  const handleAdd = () => {
    setFormField({
      ...formField,
      configData: [
        ...(formField.configData || []),
        {
          id:
            formField.configData && formField.configData.length > 0
              ? formField.configData[formField.configData.length - 1].id + 1
              : 1,
          field_name: '',
          dataType: '',
          statement: '',
        },
      ],
    });
  };

  const handleDelete = (data) => {
    const filteredData = formField.configData.filter((item) => item.id !== data.id);
    // console.log(data, filteredData, formField.configData, formField.configData.length);
    setFormField({
      ...formField,
      configData: filteredData,
    });
    // setSelectedColumnName(selectedColumnName.filter((item) => item !== data.column));
  };

  const handleChange = (event, index) => {
    const { name, value } = event.target;
    const updatedConfigData = [...formField.configData];
    updatedConfigData[index][name] = value;

    setFormField({
      ...formField,
      configData: updatedConfigData,
    });
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormField({
      ...formField,
      [name]: value,
    });
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };

  const isSelected = (name) => {
    const selectedIndex = headerName.findIndex((object) => object.statement === name);
    return selectedIndex !== -1;
  };

  const store = JSON.parse(sessionStorage.getItem('allNodes'));

  const getLocalData = () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;
      let filePath;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            setHeaderName(node.headerName);
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
            filePath = node.formField.path;
          }
        });
      });

      setFormField({ ...formField, df: prev_alias, path: filePath });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const head = [];

      const newHeader = uniqueArray.map((el) => {
        return {
          ...el,
          header: el.alias ? el.alias : el.header,
          alias: el.alias ? '' : el.alias,
        };
      });

      newHeader.forEach((el) => {
        head.push({ label: el.header });
      });

      setHeaders(head);
      setFetchedHeader(newHeader);
      setColumnName(newHeader.map((item) => ({ id: item.header, label: item.header })));

      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setHeaderName(node.headerName);
          setFetchedHeader(node.fetchedHeader);
          setTempHeader(node.headerName);
          setUniqueId(node.uniqueId);
          setColumnName(node.columnName);
          setSelectedColumnName(node.selectedColumnName);
          setConfigData(node.configData);
          // setFields(node.fields);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    setToggleType('S3');
    getLocalData();
  }, [nodeId]);

  useEffect(() => {
    if (store) {
      setTableName(
        store.map((node, i) => {
          if (node.nodeName !== 'Write') {
            return node.formField.alias;
          }
        })
      );
    }
  }, []);

  const fetchGraphs = async () => {
    setLoading(true);
    const pathType = AWS_CONFIG_TYPE
      ? formField.innerPath.split(`s3://${BUCKET_NAME}/`)[1]
      : formField.innerPath.split(`https://${AZURE_BLOB_STORAGE}.blob.core.windows.net/dep-develop/`)[1];

    try {
      const response = await fetchHtmlJsonApi(pathType, AWS_CONFIG_TYPE, workflow.engagement.client.client_id);
      if (response.status === 200) {
        const modifiedData = response.data.map((item) => ({ ...item, checked: false }));
        // setFetchedHeader(modifiedData);
        setFormField({
          ...formField,
          rule_list: modifiedData,
        });

        if (response.data.length === 0) {
          enqueueSnackbar('No Rules found', {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
      }
    } catch (error) {
      setLoading(false);
      enqueueSnackbar('Path does not exist! Internal Server Error', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    setLoading(false);
  };

  // console.log({ selectedRules });

  useEffect(() => {
    // console.log({ selectedRules });
  }, [selectedRules]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = fetchedHeader.map((n) => {
        const all = {
          statement: n.statement,
          checked: true,
        };
        return all;
      });
      setHeaderName(newSelecteds);
      return;
    }
    setHeaderName([]);
  };
  const handleHeaderChange = (obj) => {
    const selectedIndex = headerName.findIndex((object) => {
      return object.statement === obj.statement;
    });

    if (selectedIndex === -1 && obj.checked) {
      setHeaderName([...headerName, obj]);

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.statement === obj.statement) {
            return {
              statement: obj.statement,
              checked: true,
              format: obj.format,
              field_name: obj.field_name,
              unit: obj.unit,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && obj.checked) {
      setHeaderName((current) =>
        current.map((object) => {
          if (object.statement === obj.statement) {
            return {
              ...object,
              checked: obj.checked,
              statement: obj.statement,
              format: obj.format,
              field_name: obj.field_name,
              unit: obj.unit,
            };
          }

          return object;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.statement === obj.statement) {
            return {
              ...object,
              checked: obj.checked,
              statement: obj.statement,
              format: obj.format,
              field_name: obj.field_name,
              unit: obj.unit,
            };
          }

          return object;
        })
      );
    }

    if (selectedIndex !== -1 && !obj.checked) {
      setHeaderName((current) =>
        current.filter((object) => {
          return object.statement !== obj.statement;
        })
      );

      setFetchedHeader((current) =>
        current.map((object) => {
          if (object.statement === obj.statement) {
            return {
              ...object,
              checked: false,
            };
          }

          return object;
        })
      );
    }
  };

  const handleColumnAdd = () => {
    setFormField({
      ...formField,
      configData: [
        ...(formField.configData || []),
        {
          id:
            formField.configData && formField.configData.length > 0
              ? formField.configData[formField.configData.length - 1].id + 1
              : 1,
          field_name: '',
          dataType: 'string',
          statement: '',
          metric: '',
        },
      ],
    });
  };

  const handleColumnAddPredefined = () => {
    setFormField({
      ...formField,
      configDataNew: [
        ...(formField.configDataNew || []),
        {
          id:
            formField.configDataNew && formField.configDataNew.length > 0
              ? formField.configDataNew[formField.configDataNew.length - 1].id + 1
              : 1,
          field_name: '',
          dataType: 'string',
          statement: '',
          category: '',
          rule_name: '',
          metric: '',
        },
      ],
    });
  };

  const handleColumnChange = (event, index) => {
    const { name, value } = event.target;
    const updatedConfigData = [...formField.configData];
    updatedConfigData[index][name] = value;

    setFormField({
      ...formField,
      configData: updatedConfigData,
    });
  };
  const handleColumnDelete = (data) => {
    const filteredData = formField.configData.filter((item) => item.id !== data.id);
    setFormField({
      ...formField,
      configData: filteredData,
    });
  };

  const handleColumnDeletePredefined = (data) => {
    const filteredData = formField.configDataNew.filter((item) => item.id !== data.id);
    setFormField({
      ...formField,
      configDataNew: filteredData,
    });
  };

  const handleColumnChangePredefined = (event, index) => {
    const { name, value } = event.target;
    const updatedConfigData = [...formField.configDataNew];
    updatedConfigData[index][name] = value;
    setFormField({
      ...formField,
      configDataNew: updatedConfigData,
    });
  };

  return (
    <div>
      <Dialog fullScreen open={open} TransitionComponent={Transition} style={{ width: '70%', marginLeft: '30%' }}>
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {nodeName}
              </Typography>
              <Tooltip title="Refresh Schema" placement="left">
                <IconButton
                  disabled={disableForm}
                  edge="start"
                  onClick={refreshAllState}
                  aria-label="close"
                  sx={{ color: '#00043C' }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button size="small" variant="outlined" className="outlined-button-color" onClick={handleEdit}>
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>
          <div style={{ margin: '20px', padding: '10px' }}>
            <RulesSelectorPage2
              disableForm={disableForm}
              fetchedHeader={fetchedHeader}
              fetchGraphs={fetchGraphs}
              formField={formField}
              setFormField={setFormField}
              handleInputChange={handleInputChange}
              handleSelectAllClick={handleSelectAllClick}
              loading={loading}
              handleAdd={handleColumnAdd}
              handleChange={handleColumnChange}
              handleDelete={handleColumnDelete}
              handleColumnAddPredefined={handleColumnAddPredefined}
              handleColumnChangePredefined={handleColumnChangePredefined}
              handleColumnDeletePredefined={handleColumnDeletePredefined}
            />
          </div>
        </form>
      </Dialog>
    </div>
  );
}

export default NodeModalRulesSelector;
